export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.4233 8.9231H11.8079C11.4893 8.9231 11.231 9.1814 11.231 9.50002V16.4231C11.231 16.7417 11.4893 17 11.8079 17H16.4233C16.7418 17 17.0002 16.7417 17.0002 16.4231V9.50002C17.0002 9.1814 16.7418 8.9231 16.4233 8.9231Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M16.4233 2H11.8079C11.4893 2 11.231 2.2583 11.231 2.57692V4.89615C11.231 5.21478 11.4893 5.47308 11.8079 5.47308H16.4233C16.7418 5.47308 17.0002 5.21478 17.0002 4.89615V2.57692C17.0002 2.2583 16.7418 2 16.4233 2Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M7.19231 2H2.57692C2.2583 2 2 2.2583 2 2.57692V9.5C2 9.81862 2.2583 10.0769 2.57692 10.0769H7.19231C7.51093 10.0769 7.76923 9.81862 7.76923 9.5V2.57692C7.76923 2.2583 7.51093 2 7.19231 2Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M7.19231 13.527H2.57692C2.2583 13.527 2 13.7853 2 14.1039V16.4231C2 16.7417 2.2583 17.0001 2.57692 17.0001H7.19231C7.51093 17.0001 7.76923 16.7417 7.76923 16.4231V14.1039C7.76923 13.7853 7.51093 13.527 7.19231 13.527Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M16.4233 8.9231H11.8079C11.4893 8.9231 11.231 9.1814 11.231 9.50002V16.4231C11.231 16.7417 11.4893 17 11.8079 17H16.4233C16.7418 17 17.0002 16.7417 17.0002 16.4231V9.50002C17.0002 9.1814 16.7418 8.9231 16.4233 8.9231Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4233 2H11.8079C11.4893 2 11.231 2.2583 11.231 2.57692V4.89615C11.231 5.21478 11.4893 5.47308 11.8079 5.47308H16.4233C16.7418 5.47308 17.0002 5.21478 17.0002 4.89615V2.57692C17.0002 2.2583 16.7418 2 16.4233 2Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.19231 2H2.57692C2.2583 2 2 2.2583 2 2.57692V9.5C2 9.81862 2.2583 10.0769 2.57692 10.0769H7.19231C7.51093 10.0769 7.76923 9.81862 7.76923 9.5V2.57692C7.76923 2.2583 7.51093 2 7.19231 2Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.19231 13.527H2.57692C2.2583 13.527 2 13.7852 2 14.1039V16.4231C2 16.7417 2.2583 17.0001 2.57692 17.0001H7.19231C7.51093 17.0001 7.76923 16.7417 7.76923 16.4231V14.1039C7.76923 13.7852 7.51093 13.527 7.19231 13.527Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChatbotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.14307 16.1614V10.4471C2.14307 9.68935 2.44409 8.96262 2.9799 8.4268C3.51572 7.89099 4.24245 7.58997 5.00021 7.58997H15.0002C15.758 7.58997 16.4847 7.89099 17.0205 8.4268C17.5563 8.96262 17.8574 9.68935 17.8574 10.4471V16.1614C17.8574 16.9192 17.5563 17.6459 17.0205 18.1817C16.4847 18.7175 15.758 19.0185 15.0002 19.0185H5.00021C4.24245 19.0185 3.51572 18.7175 2.9799 18.1817C2.44409 17.6459 2.14307 16.9192 2.14307 16.1614Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M11.6673 2.64859C11.6673 3.09074 11.4916 3.51479 11.179 3.82744C10.8663 4.14009 10.4423 4.31573 10.0002 4.31573C9.558 4.31573 9.13395 4.14009 8.8213 3.82744C8.50865 3.51479 8.33301 3.09074 8.33301 2.64859C8.33301 2.20643 8.50865 1.78239 8.8213 1.46974C9.13395 1.15709 9.558 0.981445 10.0002 0.981445C10.4423 0.981445 10.8663 1.15709 11.179 1.46974C11.4916 1.78239 11.6673 2.20643 11.6673 2.64859Z"
      fill="white"
    />
    <path
      d="M11.6673 2.64859C11.6673 3.09074 11.4916 3.51479 11.179 3.82744C10.8663 4.14009 10.4423 4.31573 10.0002 4.31573C9.558 4.31573 9.13395 4.14009 8.8213 3.82744C8.50865 3.51479 8.33301 3.09074 8.33301 2.64859C8.33301 2.20643 8.50865 1.78239 8.8213 1.46974C9.13395 1.15709 9.558 0.981445 10.0002 0.981445C10.4423 0.981445 10.8663 1.15709 11.179 1.46974C11.4916 1.78239 11.6673 2.20643 11.6673 2.64859Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.31433V7.52862"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 15.3572C12.5 15.3572 11.7143 16.19 10 16.19C8.28571 16.19 7.5 15.3572 7.5 15.3572"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.20285 12.2029C7.10813 12.2029 7.01729 12.1653 6.95031 12.0983C6.88333 12.0314 6.8457 11.9405 6.8457 11.8458C6.8457 11.7511 6.88333 11.6602 6.95031 11.5933C7.01729 11.5263 7.10813 11.4886 7.20285 11.4886"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.20264 12.2029C7.29736 12.2029 7.3882 12.1653 7.45518 12.0983C7.52215 12.0314 7.55978 11.9405 7.55978 11.8458C7.55978 11.7511 7.52215 11.6602 7.45518 11.5933C7.3882 11.5263 7.29736 11.4886 7.20264 11.4886"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7976 12.2029C12.7029 12.2029 12.612 12.1653 12.545 12.0983C12.4781 12.0314 12.4404 11.9405 12.4404 11.8458C12.4404 11.7511 12.4781 11.6602 12.545 11.5933C12.612 11.5263 12.7029 11.4886 12.7976 11.4886"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7974 12.2029C12.8921 12.2029 12.9829 12.1653 13.0499 12.0983C13.1169 12.0314 13.1545 11.9405 13.1545 11.8458C13.1545 11.7511 13.1169 11.6602 13.0499 11.5933C12.9829 11.5263 12.8921 11.4886 12.7974 11.4886"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.14307 16.1614V10.4471C2.14307 9.68935 2.44409 8.96262 2.9799 8.4268C3.51572 7.89099 4.24245 7.58997 5.00021 7.58997H15.0002C15.758 7.58997 16.4847 7.89099 17.0205 8.4268C17.5563 8.96262 17.8574 9.68935 17.8574 10.4471V16.1614C17.8574 16.9192 17.5563 17.6459 17.0205 18.1817C16.4847 18.7175 15.758 19.0185 15.0002 19.0185H5.00021C4.24245 19.0185 3.51572 18.7175 2.9799 18.1817C2.44409 17.6459 2.14307 16.9192 2.14307 16.1614Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContactsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.59891 15.2371C2.40903 15.4271 2.25845 15.6527 2.15578 15.9009C2.0531 16.1491 2.00033 16.4152 2.00049 16.6838V2.99241C2.01425 2.45919 2.23578 1.95245 2.61784 1.58024C2.99991 1.20804 3.51226 0.999823 4.04566 1H15.6363C15.998 1 16.3448 1.14365 16.6004 1.39934C16.8561 1.65504 16.9998 2.00184 16.9998 2.36345V13.2724C16.9998 13.634 16.8561 13.9808 16.6004 14.2365C16.3448 14.4922 15.998 14.6359 15.6363 14.6359H4.04566C3.50417 14.6359 2.98211 14.8525 2.59891 15.2357V15.2371Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M4.04586 18.7289H15.6366V14.6372H4.04586C3.50327 14.6372 2.98289 14.8528 2.59922 15.2364C2.21555 15.6201 2 16.1405 2 16.6831C2 17.2257 2.21555 17.746 2.59922 18.1297C2.98289 18.5134 3.50327 18.7289 4.04586 18.7289Z"
      fill="white"
    />
    <path
      d="M10.1995 11.5258C10.6617 11.7215 11.1742 11.7649 11.6627 11.6499C12.1513 11.5348 12.5905 11.2671 12.9167 10.8857L13.2583 10.5428C13.4074 10.4233 13.5045 10.2509 13.5294 10.0614C13.5542 9.872 13.5048 9.6803 13.3916 9.52645L12.2864 8.42264C12.1327 8.30921 11.9411 8.2596 11.7517 8.28419C11.5622 8.30877 11.3897 8.40564 11.27 8.55454C11.1504 8.70305 10.9781 8.79966 10.789 8.82423C10.5999 8.84881 10.4087 8.79945 10.2551 8.68644L8.48621 6.92174C8.37278 6.76805 8.32318 6.57646 8.34776 6.38704C8.37234 6.19762 8.46921 6.02504 8.61811 5.9054C8.76723 5.78596 8.86437 5.61347 8.88921 5.42404C8.91405 5.23461 8.86467 5.04291 8.7514 4.88906L7.64621 3.78386C7.49235 3.67059 7.30065 3.62121 7.11122 3.64606C6.92179 3.6709 6.74931 3.76804 6.62987 3.91715L6.2897 4.25593C5.90949 4.58303 5.64262 5.02214 5.52739 5.51027C5.41215 5.99841 5.45446 6.5105 5.64824 6.97311C6.76833 8.84113 8.33152 10.4043 10.1995 11.5244V11.5258Z"
      fill="white"
    />
    <path
      d="M17 18.7291H4.04586C3.50327 18.7291 2.98289 18.5135 2.59922 18.1298C2.21555 17.7462 2 17.2258 2 16.6832C2 16.1406 2.21555 15.6202 2.59922 15.2365C2.98289 14.8529 3.50327 14.6373 4.04586 14.6373H15.6366C15.9982 14.6373 16.345 14.4937 16.6007 14.238C16.8564 13.9823 17 13.6355 17 13.2739V2.36491C17 2.0033 16.8564 1.65651 16.6007 1.40081C16.345 1.14511 15.9982 1.00146 15.6366 1.00146H4.04586C3.5127 1.00128 3.00055 1.2093 2.61852 1.58121C2.2365 1.95312 2.01481 2.45951 2.00069 2.99249V16.6283"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6367 14.6372V18.7289"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1995 11.5258C10.6617 11.7215 11.1742 11.7649 11.6627 11.6499C12.1513 11.5348 12.5905 11.2671 12.9167 10.8857L13.2583 10.5428C13.4074 10.4233 13.5045 10.2509 13.5294 10.0614C13.5542 9.872 13.5048 9.6803 13.3916 9.52645L12.2864 8.42264C12.1327 8.30921 11.9411 8.2596 11.7517 8.28419C11.5622 8.30877 11.3897 8.40564 11.27 8.55454C11.1504 8.70305 10.9781 8.79966 10.789 8.82423C10.5999 8.84881 10.4087 8.79945 10.2551 8.68644L8.48621 6.92174C8.37278 6.76805 8.32318 6.57646 8.34776 6.38704C8.37234 6.19762 8.46921 6.02504 8.61811 5.9054C8.76723 5.78596 8.86437 5.61347 8.88921 5.42404C8.91405 5.23461 8.86467 5.04291 8.7514 4.88906L7.64621 3.78386C7.49235 3.67059 7.30065 3.62121 7.11122 3.64606C6.92179 3.6709 6.74931 3.76804 6.62987 3.91715L6.2897 4.25593C5.90949 4.58303 5.64262 5.02214 5.52739 5.51027C5.41215 5.99841 5.45446 6.5105 5.64824 6.97311C6.76833 8.84113 8.33152 10.4043 10.1995 11.5244V11.5258Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InboxIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.75 7C16.0815 7 16.3995 7.1317 16.6339 7.36612C16.8683 7.60054 17 7.91848 17 8.25V17C17 17.3315 16.8683 17.6495 16.6339 17.8839C16.3995 18.1183 16.0815 18.25 15.75 18.25H3.25C2.91848 18.25 2.60054 18.1183 2.36612 17.8839C2.1317 17.6495 2 17.3315 2 17V8.25C2 7.91848 2.1317 7.60054 2.36612 7.36612C2.60054 7.1317 2.91848 7 3.25 7"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M6.375 6.375L9.5 9.5L12.625 6.375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 2V9.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 7C16.0815 7 16.3995 7.1317 16.6339 7.36612C16.8683 7.60054 17 7.91848 17 8.25V17C17 17.3315 16.8683 17.6495 16.6339 17.8839C16.3995 18.1183 16.0815 18.25 15.75 18.25H3.25C2.91848 18.25 2.60054 18.1183 2.36612 17.8839C2.1317 17.6495 2 17.3315 2 17V8.25C2 7.91848 2.1317 7.60054 2.36612 7.36612C2.60054 7.1317 2.91848 7 3.25 7"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 8.57495L9.5 13.875L17 8.57495"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HistoryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle cx="9.5" cy="9.5" r="7.5" fill="currentColor" fillOpacity="0.1" />
    <path
      d="M9.5 5.46155V10.0769L12.5 11.5769"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7993 11.2308C16.018 14.5385 13.0465 17 9.5 17C5.35787 17 2 13.6422 2 9.5C2 5.35787 5.35787 2 9.5 2C12.3935 2 14.9044 3.63859 16.1552 6.03846"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M16.9998 3.73071V6.61533H14.1152"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TeamIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M13.7856 8.35718C12.9331 8.35718 12.1155 8.69582 11.5127 9.29862C10.9099 9.90142 10.5713 10.719 10.5713 11.5715V12.6429H16.9999V11.5715C16.9999 10.719 16.6612 9.90142 16.0584 9.29862C15.4556 8.69582 14.6381 8.35718 13.7856 8.35718Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M11.6431 5.14286C11.6431 5.71118 11.8688 6.25622 12.2707 6.65809C12.6726 7.05995 13.2176 7.28571 13.7859 7.28571C14.3542 7.28571 14.8993 7.05995 15.3012 6.65809C15.703 6.25622 15.9288 5.71118 15.9288 5.14286C15.9288 4.57454 15.703 4.02949 15.3012 3.62763C14.8993 3.22576 14.3542 3 13.7859 3C13.2176 3 12.6726 3.22576 12.2707 3.62763C11.8688 4.02949 11.6431 4.57454 11.6431 5.14286Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M17 12.6428V11.5714C17.0002 10.8586 16.7635 10.166 16.3271 9.60245C15.8907 9.0389 15.2793 8.63639 14.5892 8.45823C13.899 8.28007 13.1692 8.33636 12.5146 8.61825C11.8599 8.90014 11.3175 9.39164 10.9727 10.0155"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.07129 5.14286C3.07129 5.71118 3.29705 6.25622 3.69892 6.65809C4.10078 7.05995 4.64583 7.28571 5.21415 7.28571C5.78247 7.28571 6.32751 7.05995 6.72938 6.65809C7.13124 6.25622 7.357 5.71118 7.357 5.14286C7.357 4.57454 7.13124 4.02949 6.72938 3.62763C6.32751 3.22576 5.78247 3 5.21415 3C4.64583 3 4.10078 3.22576 3.69892 3.62763C3.29705 4.02949 3.07129 4.57454 3.07129 5.14286Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M5.21429 8.35718C4.3618 8.35718 3.54424 8.69582 2.94144 9.29862C2.33865 9.90142 2 10.719 2 11.5715V12.6429H8.42857V11.5715C8.42857 10.719 8.08992 9.90142 7.48713 9.29862C6.88433 8.69582 6.06677 8.35718 5.21429 8.35718Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M7.3584 11.569C7.3584 12.1373 7.58416 12.6824 7.98603 13.0842C8.38789 13.4861 8.93293 13.7119 9.50126 13.7119C10.0696 13.7119 10.6146 13.4861 11.0165 13.0842C11.4183 12.6824 11.6441 12.1373 11.6441 11.569C11.6441 11.0007 11.4183 10.4556 11.0165 10.0538C10.6146 9.65191 10.0696 9.42615 9.50126 9.42615C8.93293 9.42615 8.38789 9.65191 7.98603 10.0538C7.58416 10.4556 7.3584 11.0007 7.3584 11.569Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M11.6431 5.14286C11.6431 5.71118 11.8688 6.25622 12.2707 6.65809C12.6726 7.05995 13.2176 7.28571 13.7859 7.28571C14.3542 7.28571 14.8993 7.05995 15.3012 6.65809C15.703 6.25622 15.9288 5.71118 15.9288 5.14286C15.9288 4.57454 15.703 4.02949 15.3012 3.62763C14.8993 3.22576 14.3542 3 13.7859 3C13.2176 3 12.6726 3.22576 12.2707 3.62763C11.8688 4.02949 11.6431 4.57454 11.6431 5.14286Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.07129 5.14286C3.07129 5.71118 3.29705 6.25622 3.69892 6.65809C4.10078 7.05995 4.64583 7.28571 5.21415 7.28571C5.78247 7.28571 6.32751 7.05995 6.72938 6.65809C7.13124 6.25622 7.357 5.71118 7.357 5.14286C7.357 4.57454 7.13124 4.02949 6.72938 3.62763C6.32751 3.22576 5.78247 3 5.21415 3C4.64583 3 4.10078 3.22576 3.69892 3.62763C3.29705 4.02949 3.07129 4.57454 3.07129 5.14286Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.3584 11.569C7.3584 12.1373 7.58416 12.6824 7.98603 13.0842C8.38789 13.4861 8.93293 13.7119 9.50126 13.7119C10.0696 13.7119 10.6146 13.4861 11.0165 13.0842C11.4183 12.6824 11.6441 12.1373 11.6441 11.569C11.6441 11.0007 11.4183 10.4556 11.0165 10.0538C10.6146 9.65191 10.0696 9.42615 9.50126 9.42615C8.93293 9.42615 8.38789 9.65191 7.98603 10.0538C7.58416 10.4556 7.3584 11.0007 7.3584 11.569Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.50139 14.7833C8.64891 14.7833 7.83135 15.122 7.22855 15.7248C6.62576 16.3276 6.28711 17.1451 6.28711 17.9976H12.7157C12.7157 17.1451 12.377 16.3276 11.7742 15.7248C11.1714 15.122 10.3539 14.7833 9.50139 14.7833Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M12.7157 17.9976C12.7157 17.1451 12.377 16.3276 11.7742 15.7248C11.1714 15.122 10.3539 14.7833 9.50139 14.7833C8.64891 14.7833 7.83135 15.122 7.22855 15.7248C6.62576 16.3276 6.28711 17.1451 6.28711 17.9976"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 12.6428V11.5714C1.9998 10.8586 2.23652 10.166 2.67294 9.60245C3.10935 9.0389 3.72071 8.63639 4.41086 8.45823C5.10102 8.28007 5.83081 8.33636 6.48548 8.61825C7.14015 8.90014 7.68255 9.39164 8.02738 10.0155"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CampaignsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.71473 15.7348L13.8758 13.1423L9.82333 6.12756L2 14.4955L2.71473 15.7348Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M2.71484 15.7349L13.8759 13.1423"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 14.4955L9.82451 6.12756"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.71473 15.7348L13.8758 13.1423L9.82333 6.12756L2 14.4955L2.71473 15.7348Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.58496 5.71338L14.1116 13.5543"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8745 13.1423L2.71336 15.7348L2.00098 14.4955L9.82431 6.12756"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.1416 15.1703L5.75658 16.2336C5.97944 16.6157 6.34496 16.8936 6.77271 17.0062C7.20047 17.1187 7.65543 17.0568 8.0375 16.8339C8.41958 16.611 8.69747 16.2455 8.81005 15.8178C8.92263 15.39 8.86067 14.9351 8.63781 14.553L8.53922 14.3828"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.89258 3.47172V2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5283 9.10852H17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.78613 9.10852H4.25667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.86572 4.08203L5.90555 5.12303"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8779 5.12303L14.9178 4.08203"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MetricsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M17 2H12.0962V17H17V2Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M12.0961 6.61536H6.90381V17H12.0961"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M6.90385 10.0769H2V17H6.90385"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M6.90385 10.0769H2V17H6.90385"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0961 6.61536H6.90381V17H12.0961"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 2H12.0962V17H17V2Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="12.5"
    viewBox="0 0 20 12.5"
    fill="none"
  >
    <path
      d="M1.927 12.1193C1.7055 12.1193 1.52 12.0443 1.3704 11.8945C1.2205 11.7449 1.14551 11.5593 1.14551 11.3377C1.14551 11.1164 1.2205 10.9309 1.3704 10.7813C1.52 10.6316 1.7055 10.5564 1.927 10.5564H18.073C18.2945 10.5564 18.48 10.6317 18.6296 10.7816C18.7795 10.9315 18.8545 11.117 18.8545 11.3385C18.8545 11.5598 18.7795 11.7453 18.6296 11.8949C18.48 12.0443 18.2945 12.1193 18.073 12.1193H1.927ZM1.927 7.03123C1.7055 7.03123 1.52 6.95624 1.3704 6.80638C1.2205 6.65653 1.14551 6.47102 1.14551 6.24957C1.14551 6.02807 1.2205 5.84257 1.3704 5.69297C1.52 5.5431 1.7055 5.46823 1.927 5.46823H18.073C18.2945 5.46823 18.48 5.54317 18.6296 5.69303C18.7795 5.84289 18.8545 6.0284 18.8545 6.2499C18.8545 6.4714 18.7795 6.6569 18.6296 6.80676C18.48 6.95662 18.2945 7.03123 18.073 7.03123H1.927ZM1.927 1.94295C1.7055 1.94295 1.52 1.86808 1.3704 1.71821C1.2205 1.56835 1.14551 1.38285 1.14551 1.16135C1.14551 0.939847 1.2205 0.754344 1.3704 0.604489C1.52 0.454628 1.7055 0.379693 1.927 0.379693H18.073C18.2945 0.379693 18.48 0.454697 18.6296 0.604561C18.7795 0.754426 18.8545 0.939927 18.8545 1.16143C18.8545 1.38294 18.7795 1.56844 18.6296 1.7183C18.48 1.86815 18.2945 1.94295 18.073 1.94295H1.927Z"
      fill="currentColor"
    />
  </svg>
);

export const NotificationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M7.63623 16.6819H10.3635"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4545 6.45455C14.4545 5.0079 13.8799 3.62053 12.857 2.5976C11.834 1.57468 10.4466 1 9 1C7.55336 1 6.16598 1.57468 5.14305 2.5976C4.12013 3.62053 3.54545 5.0079 3.54545 6.45455V11.2273C3.54545 11.7698 3.32995 12.2901 2.94635 12.6737C2.56276 13.0573 2.04248 13.2727 1.5 13.2727H16.5C15.9575 13.2727 15.4372 13.0573 15.0536 12.6737C14.67 12.2901 14.4545 11.7698 14.4545 11.2273V6.45455Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M14.4545 6.45455C14.4545 5.0079 13.8799 3.62053 12.857 2.5976C11.834 1.57468 10.4466 1 9 1C7.55336 1 6.16598 1.57468 5.14305 2.5976C4.12013 3.62053 3.54545 5.0079 3.54545 6.45455V11.2273C3.54545 11.7698 3.32995 12.2901 2.94635 12.6737C2.56276 13.0573 2.04248 13.2727 1.5 13.2727H16.5C15.9575 13.2727 15.4372 13.0573 15.0536 12.6737C14.67 12.2901 14.4545 11.7698 14.4545 11.2273V6.45455Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HelpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.88477 9.50073V6.46611C4.89378 5.86961 5.0204 5.28075 5.25739 4.73327C5.49437 4.18579 5.83705 3.69045 6.2658 3.27564C6.69455 2.86082 7.20094 2.53469 7.75595 2.31591C8.31095 2.09714 8.90368 1.99003 9.50015 2.00073C10.0966 1.99003 10.6893 2.09714 11.2444 2.31591C11.7994 2.53469 12.3057 2.86082 12.7345 3.27564C13.1632 3.69045 13.5059 4.18579 13.7429 4.73327C13.9799 5.28075 14.1065 5.86961 14.1155 6.46611V9.50073"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.15385 7.77002H4.30769C4.4607 7.77002 4.60744 7.8308 4.71564 7.939C4.82383 8.04719 4.88462 8.19393 4.88462 8.34694V11.8085C4.88462 11.9615 4.82383 12.1082 4.71564 12.2164C4.60744 12.3246 4.4607 12.3854 4.30769 12.3854H3.15385C2.84783 12.3854 2.55434 12.2638 2.33795 12.0475C2.12157 11.8311 2 11.5376 2 11.2316V8.92387C2 8.61785 2.12157 8.32436 2.33795 8.10797C2.55434 7.89159 2.84783 7.77002 3.15385 7.77002Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M15.846 12.3854H14.6922C14.5391 12.3854 14.3924 12.3246 14.2842 12.2164C14.176 12.1082 14.1152 11.9615 14.1152 11.8085V8.34694C14.1152 8.19393 14.176 8.04719 14.2842 7.939C14.3924 7.8308 14.5391 7.77002 14.6922 7.77002H15.846C16.152 7.77002 16.4455 7.89159 16.6619 8.10797C16.8783 8.32436 16.9998 8.61785 16.9998 8.92387V11.2316C16.9998 11.5376 16.8783 11.8311 16.6619 12.0475C16.4455 12.2638 16.152 12.3854 15.846 12.3854Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M11.8076 15.5584C12.4197 15.5584 13.0066 15.3153 13.4394 14.8825C13.8722 14.4497 14.1153 13.8627 14.1153 13.2507V10.6545"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8078 15.5583C11.8078 15.9408 11.6558 16.3077 11.3853 16.5781C11.1148 16.8486 10.748 17.0006 10.3655 17.0006H8.63469C8.25217 17.0006 7.88531 16.8486 7.61482 16.5781C7.34434 16.3077 7.19238 15.9408 7.19238 15.5583C7.19238 15.1758 7.34434 14.8089 7.61482 14.5384C7.88531 14.2679 8.25217 14.116 8.63469 14.116H10.3655C10.748 14.116 11.1148 14.2679 11.3853 14.5384C11.6558 14.8089 11.8078 15.1758 11.8078 15.5583Z"
      fill="currentColor"
      fillOpacity="0.101961"
    />
    <path
      d="M3.15385 7.77002H4.30769C4.4607 7.77002 4.60744 7.8308 4.71564 7.939C4.82383 8.04719 4.88462 8.19393 4.88462 8.34694V11.8085C4.88462 11.9615 4.82383 12.1082 4.71564 12.2164C4.60744 12.3246 4.4607 12.3854 4.30769 12.3854H3.15385C2.84783 12.3854 2.55434 12.2638 2.33795 12.0475C2.12157 11.8311 2 11.5376 2 11.2316V8.92387C2 8.61785 2.12157 8.32436 2.33795 8.10797C2.55434 7.89159 2.84783 7.77002 3.15385 7.77002Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.846 12.3854H14.6922C14.5391 12.3854 14.3924 12.3246 14.2842 12.2164C14.176 12.1082 14.1152 11.9615 14.1152 11.8085V8.34694C14.1152 8.19393 14.176 8.04719 14.2842 7.939C14.3924 7.8308 14.5391 7.77002 14.6922 7.77002H15.846C16.152 7.77002 16.4455 7.89159 16.6619 8.10797C16.8783 8.32436 16.9998 8.61785 16.9998 8.92387V11.2316C16.9998 11.5376 16.8783 11.8311 16.6619 12.0475C16.4455 12.2638 16.152 12.3854 15.846 12.3854Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8078 15.5583C11.8078 15.9408 11.6558 16.3077 11.3853 16.5781C11.1148 16.8486 10.748 17.0006 10.3655 17.0006H8.63469C8.25217 17.0006 7.88531 16.8486 7.61482 16.5781C7.34434 16.3077 7.19238 15.9408 7.19238 15.5583C7.19238 15.1758 7.34434 14.8089 7.61482 14.5384C7.88531 14.2679 8.25217 14.116 8.63469 14.116H10.3655C10.748 14.116 11.1148 14.2679 11.3853 14.5384C11.6558 14.8089 11.8078 15.1758 11.8078 15.5583Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MyCompanyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_349_964"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_349_964)">
      <path
        d="M4.30225 16.6475C3.99613 16.6475 3.73732 16.5407 3.52579 16.3271C3.31426 16.1134 3.2085 15.8537 3.2085 15.5482V7.16338C3.2085 6.85782 3.31509 6.59824 3.52829 6.38463C3.74134 6.17101 4.00037 6.06421 4.30537 6.06421H6.2037V4.16338C6.2037 3.85782 6.3103 3.59824 6.5235 3.38463C6.73655 3.17101 6.99613 3.06421 7.30225 3.06421H12.191C12.4971 3.06421 12.7571 3.17101 12.971 3.38463C13.1849 3.59824 13.2918 3.85782 13.2918 4.16338V9.06421H15.6925C15.9981 9.06421 16.2578 9.17101 16.4714 9.38463C16.685 9.59824 16.7918 9.85782 16.7918 10.1634V15.5482C16.7918 15.8537 16.685 16.1134 16.4714 16.3271C16.2578 16.5407 15.9981 16.6475 15.6925 16.6475H11.2085V13.6475H8.79183V16.6475H4.30225ZM4.29183 15.5642H6.2085V13.6475H4.29183V15.5642ZM4.29183 12.3142H6.2085V10.3975H4.29183V12.3142ZM4.29183 9.06421H6.2085V7.14754H4.29183V9.06421ZM7.29183 12.3142H9.2085V10.3975H7.29183V12.3142ZM7.29183 9.06421H9.2085V7.14754H7.29183V9.06421ZM7.29183 6.06421H9.2085V4.14754H7.29183V6.06421ZM10.2918 12.3142H12.2085V10.3975H10.2918V12.3142ZM10.2918 9.06421H12.2085V7.14754H10.2918V9.06421ZM10.2918 6.06421H12.2085V4.14754H10.2918V6.06421ZM13.7918 15.5642H15.7085V13.6475H13.7918V15.5642ZM13.7918 12.3142H15.7085V10.3975H13.7918V12.3142Z"
        fill="#424242"
      />
    </g>
  </svg>
);

export const MyProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_349_865"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_349_865)">
      <path
        d="M14.8879 10.609C15.0652 10.609 15.2138 10.5491 15.3335 10.4294C15.4531 10.3098 15.5129 10.1613 15.5129 9.98396C15.5129 9.8066 15.4531 9.65813 15.3335 9.53854C15.2138 9.41882 15.0652 9.35896 14.8879 9.35896H12.356C12.1786 9.35896 12.0301 9.41882 11.9104 9.53854C11.7908 9.65813 11.731 9.8066 11.731 9.98396C11.731 10.1613 11.7908 10.3098 11.9104 10.4294C12.0301 10.5491 12.1786 10.609 12.356 10.609H14.8879ZM14.8879 8.20521C15.0652 8.20521 15.2138 8.14535 15.3335 8.02562C15.4531 7.90604 15.5129 7.75757 15.5129 7.58021C15.5129 7.40285 15.4531 7.25431 15.3335 7.13458C15.2138 7.015 15.0652 6.95521 14.8879 6.95521H12.356C12.1786 6.95521 12.0301 7.015 11.9104 7.13458C11.7908 7.25431 11.731 7.40285 11.731 7.58021C11.731 7.75757 11.7908 7.90604 11.9104 8.02562C12.0301 8.14535 12.1786 8.20521 12.356 8.20521H14.8879ZM7.53225 10.9615C7.05364 10.9615 6.63426 10.9999 6.27412 11.0769C5.91412 11.1538 5.59468 11.2762 5.31579 11.444C5.06162 11.5924 4.86884 11.7585 4.73745 11.9423C4.60593 12.126 4.54016 12.3231 4.54016 12.5335C4.54016 12.679 4.596 12.8005 4.70766 12.8981C4.81933 12.9959 4.95745 13.0448 5.12204 13.0448H9.94245C10.107 13.0448 10.2451 12.9924 10.3566 12.8877C10.4683 12.7831 10.5241 12.6539 10.5241 12.5C10.5241 12.3119 10.4597 12.1295 10.331 11.9527C10.2022 11.7759 10.0081 11.6063 9.7485 11.444C9.46975 11.2762 9.1503 11.1538 8.79016 11.0769C8.43016 10.9999 8.01086 10.9615 7.53225 10.9615ZM7.53225 9.87187C7.93711 9.87187 8.28134 9.73 8.56495 9.44625C8.8487 9.16264 8.99058 8.8184 8.99058 8.41354C8.99058 8.00854 8.8487 7.66424 8.56495 7.38063C8.28134 7.09701 7.93711 6.95521 7.53225 6.95521C7.12739 6.95521 6.78308 7.09701 6.49933 7.38063C6.21572 7.66424 6.07391 8.00854 6.07391 8.41354C6.07391 8.8184 6.21572 9.16264 6.49933 9.44625C6.78308 9.73 7.12739 9.87187 7.53225 9.87187ZM3.58995 16.25C3.16898 16.25 2.81266 16.1042 2.521 15.8125C2.22933 15.5208 2.0835 15.1645 2.0835 14.7435V5.25646C2.0835 4.83549 2.22933 4.47917 2.521 4.1875C2.81266 3.89583 3.16898 3.75 3.58995 3.75H16.4104C16.8313 3.75 17.1877 3.89583 17.4793 4.1875C17.771 4.47917 17.9168 4.83549 17.9168 5.25646V14.7435C17.9168 15.1645 17.771 15.5208 17.4793 15.8125C17.1877 16.1042 16.8313 16.25 16.4104 16.25H3.58995ZM3.58995 15H16.4104C16.4745 15 16.5333 14.9733 16.5866 14.9198C16.6401 14.8665 16.6668 14.8077 16.6668 14.7435V5.25646C16.6668 5.19229 16.6401 5.13354 16.5866 5.08021C16.5333 5.02674 16.4745 5 16.4104 5H3.58995C3.52579 5 3.46704 5.02674 3.4137 5.08021C3.36023 5.13354 3.3335 5.19229 3.3335 5.25646V14.7435C3.3335 14.8077 3.36023 14.8665 3.4137 14.9198C3.46704 14.9733 3.52579 15 3.58995 15Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const BillingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_349_970"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_349_970)">
      <path
        d="M3.7563 15.5834C3.38116 15.5834 3.06407 15.4538 2.80505 15.1947C2.54602 14.9355 2.4165 14.6182 2.4165 14.2428V5.75071C2.4165 5.37529 2.54602 5.05911 2.80505 4.80216C3.06407 4.54522 3.38116 4.41675 3.7563 4.41675H16.2434C16.6185 4.41675 16.9356 4.54633 17.1946 4.8055C17.4537 5.06466 17.5832 5.38196 17.5832 5.75737V14.2495C17.5832 14.6249 17.4537 14.9411 17.1946 15.198C16.9356 15.4549 16.6185 15.5834 16.2434 15.5834H3.7563ZM3.7563 14.5001H16.2434C16.3075 14.5001 16.3663 14.4733 16.4196 14.4199C16.4731 14.3665 16.4998 14.3078 16.4998 14.2436V5.75654C16.4998 5.69237 16.4731 5.63362 16.4196 5.58029C16.3663 5.52682 16.3075 5.50008 16.2434 5.50008H3.7563C3.69213 5.50008 3.63338 5.52682 3.58005 5.58029C3.52657 5.63362 3.49984 5.69237 3.49984 5.75654V14.2436C3.49984 14.3078 3.52657 14.3665 3.58005 14.4199C3.63338 14.4733 3.69213 14.5001 3.7563 14.5001ZM8.70817 11.7084H5.74984C5.59609 11.7084 5.46741 11.7599 5.3638 11.8628C5.26005 11.9656 5.20817 12.0932 5.20817 12.2457C5.20817 12.3982 5.26005 12.5273 5.3638 12.633C5.46741 12.7388 5.59609 12.7917 5.74984 12.7917H6.95817V13.2501C6.95817 13.4038 7.00963 13.5325 7.11255 13.6361C7.21532 13.7399 7.34296 13.7917 7.49546 13.7917C7.64796 13.7917 7.77706 13.7399 7.88275 13.6361C7.98859 13.5325 8.0415 13.4038 8.0415 13.2501V12.7917H8.88755C9.14421 12.7917 9.35907 12.7053 9.53213 12.5324C9.70505 12.3593 9.7915 12.1445 9.7915 11.8878V10.3624C9.7915 10.1057 9.70505 9.89085 9.53213 9.71779C9.35907 9.54487 9.14421 9.45842 8.88755 9.45842H6.2915V8.29175H9.24984C9.40359 8.29175 9.53227 8.24029 9.63588 8.13737C9.73963 8.0346 9.7915 7.90696 9.7915 7.75446C9.7915 7.60196 9.73963 7.47286 9.63588 7.36716C9.53227 7.26133 9.40359 7.20841 9.24984 7.20841H8.0415V6.75008C8.0415 6.59633 7.99005 6.46765 7.88713 6.36404C7.78435 6.26029 7.65671 6.20841 7.50421 6.20841C7.35171 6.20841 7.22261 6.26029 7.11692 6.36404C7.01109 6.46765 6.95817 6.59633 6.95817 6.75008V7.20841H6.11213C5.85546 7.20841 5.6406 7.29487 5.46755 7.46779C5.29463 7.64085 5.20817 7.85571 5.20817 8.11237V9.63779C5.20817 9.89446 5.29463 10.1093 5.46755 10.2824C5.6406 10.4553 5.85546 10.5417 6.11213 10.5417H8.70817V11.7084ZM13.6088 12.7788L14.5271 11.8607C14.5912 11.7965 14.6037 11.7338 14.5646 11.6724C14.5257 11.611 14.4684 11.5803 14.3925 11.5803H12.6071C12.5313 11.5803 12.4739 11.611 12.435 11.6724C12.396 11.7338 12.4085 11.7965 12.4725 11.8607L13.3909 12.7788C13.4213 12.8152 13.4576 12.8334 13.4998 12.8334C13.5421 12.8334 13.5784 12.8152 13.6088 12.7788ZM12.6071 8.41987H14.3925C14.4684 8.41987 14.5257 8.38918 14.5646 8.32779C14.6037 8.2664 14.5912 8.20362 14.5271 8.13946L13.6088 7.22133C13.5784 7.18494 13.5421 7.16675 13.4998 7.16675C13.4576 7.16675 13.4213 7.18494 13.3909 7.22133L12.4725 8.13946C12.4085 8.20362 12.396 8.2664 12.435 8.32779C12.4739 8.38918 12.5313 8.41987 12.6071 8.41987Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const InvoicesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_349_976"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_349_976)">
      <path
        d="M4.99984 17.5833C4.47317 17.5833 4.07761 17.4545 3.81317 17.197C3.54873 16.9395 3.4165 16.5405 3.4165 15.9999V14.0866C3.4165 13.8995 3.48143 13.7411 3.6113 13.6114C3.74102 13.4815 3.89942 13.4166 4.0865 13.4166H5.4165V2.94702C5.4165 2.87438 5.44456 2.81993 5.50067 2.78368C5.55678 2.74729 5.61685 2.75583 5.68088 2.80931L6.314 3.33806C6.37275 3.38611 6.44435 3.41014 6.5288 3.41014C6.6131 3.41014 6.68463 3.38611 6.74338 3.33806L7.4213 2.76764C7.48005 2.71958 7.55164 2.69556 7.63609 2.69556C7.72053 2.69556 7.79213 2.71958 7.85088 2.76764L8.54963 3.33806C8.60838 3.38611 8.67991 3.41014 8.76421 3.41014C8.84866 3.41014 8.92025 3.38611 8.979 3.33806L9.65692 2.76764C9.71567 2.71958 9.78727 2.69556 9.87171 2.69556C9.95602 2.69556 10.0275 2.71958 10.0863 2.76764L10.785 3.33806C10.8438 3.38611 10.9154 3.41014 10.9998 3.41014C11.0843 3.41014 11.1559 3.38611 11.2146 3.33806L11.9134 2.76764C11.9721 2.71958 12.0437 2.69556 12.128 2.69556C12.2124 2.69556 12.284 2.71958 12.3428 2.76764L13.0207 3.33806C13.0794 3.38611 13.151 3.41014 13.2355 3.41014C13.3198 3.41014 13.3913 3.38611 13.45 3.33806L14.1488 2.76764C14.2075 2.71958 14.2791 2.69556 14.3636 2.69556C14.448 2.69556 14.5196 2.71958 14.5784 2.76764L15.2563 3.33806C15.315 3.38611 15.3866 3.41014 15.4709 3.41014C15.5553 3.41014 15.6269 3.38611 15.6857 3.33806L16.3188 2.80931C16.3828 2.75583 16.4429 2.74729 16.499 2.78368C16.5551 2.81993 16.5832 2.87438 16.5832 2.94702V15.7499C16.5832 16.2905 16.4093 16.7312 16.0615 17.072C15.7137 17.4128 15.2765 17.5833 14.7498 17.5833H4.99984ZM14.7498 16.4999C14.9721 16.4999 15.1526 16.434 15.2915 16.302C15.4304 16.1701 15.4998 15.986 15.4998 15.7499V4.49993H6.49984V13.4166H13.33C13.517 13.4166 13.6753 13.4815 13.805 13.6114C13.9349 13.7411 13.9998 13.8995 13.9998 14.0866V15.7499C13.9998 15.986 14.0693 16.1701 14.2082 16.302C14.3471 16.434 14.5276 16.4999 14.7498 16.4999ZM8.20171 6.20826H11.3461C11.4955 6.20826 11.6232 6.26118 11.729 6.36701C11.8347 6.47271 11.8875 6.60035 11.8875 6.74993C11.8875 6.89951 11.8347 7.02715 11.729 7.13285C11.6232 7.23868 11.4955 7.2916 11.3461 7.2916H8.20171C8.05213 7.2916 7.92449 7.23868 7.8188 7.13285C7.71296 7.02715 7.66005 6.89951 7.66005 6.74993C7.66005 6.60035 7.71296 6.47271 7.8188 6.36701C7.92449 6.26118 8.05213 6.20826 8.20171 6.20826ZM8.20171 8.70826H11.3461C11.4955 8.70826 11.6232 8.76118 11.729 8.86701C11.8347 8.97271 11.8875 9.10035 11.8875 9.24993C11.8875 9.39951 11.8347 9.52715 11.729 9.63285C11.6232 9.73868 11.4955 9.7916 11.3461 9.7916H8.20171C8.05213 9.7916 7.92449 9.73868 7.8188 9.63285C7.71296 9.52715 7.66005 9.39951 7.66005 9.24993C7.66005 9.10035 7.71296 8.97271 7.8188 8.86701C7.92449 8.76118 8.05213 8.70826 8.20171 8.70826ZM13.7017 7.40368C13.5394 7.40368 13.3898 7.33882 13.253 7.2091C13.1163 7.07924 13.048 6.92618 13.048 6.74993C13.048 6.57368 13.1163 6.42063 13.253 6.29077C13.3898 6.16104 13.5394 6.09618 13.7017 6.09618C13.878 6.09618 14.031 6.16104 14.1609 6.29077C14.2907 6.42063 14.3557 6.57368 14.3557 6.74993C14.3557 6.92618 14.2907 7.07924 14.1609 7.2091C14.031 7.33882 13.878 7.40368 13.7017 7.40368ZM13.7017 9.90368C13.5394 9.90368 13.3898 9.83882 13.253 9.7091C13.1163 9.57924 13.048 9.42618 13.048 9.24993C13.048 9.07368 13.1163 8.92063 13.253 8.79077C13.3898 8.66104 13.5394 8.59618 13.7017 8.59618C13.878 8.59618 14.031 8.66104 14.1609 8.79077C14.2907 8.92063 14.3557 9.07368 14.3557 9.24993C14.3557 9.42618 14.2907 9.57924 14.1609 9.7091C14.031 9.83882 13.878 9.90368 13.7017 9.90368ZM4.99984 16.4999H12.9165V14.4999H4.49984V15.9999C4.49984 16.236 4.52414 16.3784 4.57275 16.427C4.62137 16.4756 4.76373 16.4999 4.99984 16.4999Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const SupportChatbotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_351_649"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_351_649)">
      <path
        d="M9.86213 16.5834C9.70838 16.5834 9.57963 16.532 9.47588 16.429C9.37227 16.3263 9.32046 16.1986 9.32046 16.0461C9.32046 15.8936 9.37227 15.7645 9.47588 15.6588C9.57963 15.553 9.70838 15.5001 9.86213 15.5001H15.2434C15.3128 15.5001 15.373 15.4787 15.4238 15.4359C15.4745 15.3933 15.4998 15.3372 15.4998 15.2678V9.79321C15.4998 8.29751 14.9626 7.03286 13.8882 5.99925C12.8139 4.96564 11.5193 4.44883 10.0044 4.44883C8.48956 4.44883 7.19345 4.96564 6.11609 5.99925C5.03859 7.03286 4.49984 8.29557 4.49984 9.78737V13.8045C4.49984 13.9582 4.44796 14.087 4.34421 14.1907C4.2406 14.2943 4.11192 14.3461 3.95817 14.3461H3.70817C3.35442 14.3461 3.05074 14.2192 2.79713 13.9655C2.54338 13.7116 2.4165 13.4021 2.4165 13.037V11.5434C2.4165 11.2454 2.51081 10.9873 2.69942 10.7692C2.88803 10.5513 3.12706 10.4157 3.4165 10.3624L3.45505 9.33987C3.53727 8.50223 3.76241 7.72098 4.13046 6.99612C4.49852 6.27126 4.97685 5.64307 5.56546 5.11154C6.15421 4.58001 6.82963 4.16466 7.59171 3.8655C8.3538 3.56633 9.15643 3.41675 9.99963 3.41675C10.8427 3.41675 11.6453 3.56675 12.4075 3.86675C13.1698 4.16661 13.8453 4.58328 14.434 5.11675C15.0228 5.65008 15.5025 6.27571 15.8732 6.99362C16.2439 7.71168 16.4677 8.48946 16.5446 9.32696L16.5832 10.3703C16.8534 10.429 17.0877 10.5543 17.2859 10.7461C17.4841 10.9379 17.5832 11.1786 17.5832 11.468V13.162C17.5832 13.4514 17.4841 13.692 17.2859 13.8838C17.0877 14.0756 16.8534 14.2009 16.5832 14.2597V15.2678C16.5832 15.6321 16.4523 15.9424 16.1907 16.1988C15.9289 16.4552 15.6131 16.5834 15.2434 16.5834H9.86213ZM7.91442 11.3078C7.73525 11.3078 7.58074 11.247 7.45088 11.1255C7.32116 11.004 7.2563 10.8536 7.2563 10.6742C7.2563 10.4951 7.3197 10.342 7.4465 10.2149C7.57345 10.0877 7.7265 10.024 7.90567 10.024C8.08498 10.024 8.23949 10.0862 8.36921 10.2105C8.49907 10.3347 8.564 10.4863 8.564 10.6655C8.564 10.8448 8.50053 10.9967 8.37359 11.1211C8.24678 11.2456 8.09373 11.3078 7.91442 11.3078ZM12.094 11.3078C11.9147 11.3078 11.7602 11.247 11.6305 11.1255C11.5006 11.004 11.4357 10.8536 11.4357 10.6742C11.4357 10.4951 11.4991 10.342 11.6261 10.2149C11.7529 10.0877 11.9059 10.024 12.0853 10.024C12.2644 10.024 12.4189 10.0862 12.5488 10.2105C12.6785 10.3347 12.7434 10.4863 12.7434 10.6655C12.7434 10.8448 12.68 10.9967 12.5532 11.1211C12.4262 11.2456 12.2732 11.3078 12.094 11.3078ZM5.80921 10.2501C5.69491 9.01508 6.06032 7.95203 6.90546 7.06091C7.75074 6.16994 8.79609 5.72446 10.0415 5.72446C11.1003 5.72446 12.023 6.07168 12.8098 6.76612C13.5968 7.46057 14.05 8.33446 14.1696 9.38779C13.0692 9.38779 12.0657 9.09432 11.1592 8.50737C10.2527 7.92029 9.55157 7.14598 9.05588 6.18446C8.87213 7.09571 8.49824 7.90765 7.93421 8.62029C7.37005 9.33293 6.66171 9.87619 5.80921 10.2501Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const BookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_351_655"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_351_655)">
      <path
        d="M5.34609 17.5834C4.81011 17.5834 4.35449 17.3958 3.97921 17.0207C3.60407 16.6454 3.4165 16.1898 3.4165 15.6538V4.34633C3.4165 3.81036 3.60407 3.35473 3.97921 2.97946C4.35449 2.60432 4.81011 2.41675 5.34609 2.41675H12.4998C12.8683 2.41675 13.1837 2.54793 13.4461 2.81029C13.7084 3.07265 13.8396 3.38807 13.8396 3.75654V13.5001C13.8396 13.8686 13.7084 14.184 13.4461 14.4463C13.1837 14.7087 12.8683 14.8399 12.4998 14.8399H5.34609C5.1122 14.8399 4.91268 14.9188 4.74755 15.0767C4.58241 15.2348 4.49984 15.4306 4.49984 15.6642C4.49984 15.8977 4.58241 16.0954 4.74755 16.2574C4.91268 16.4192 5.1122 16.5001 5.34609 16.5001H15.2434C15.3182 16.5001 15.3797 16.4761 15.4278 16.428C15.4758 16.3799 15.4998 16.3185 15.4998 16.2436V4.45841C15.4998 4.30494 15.5514 4.17633 15.6544 4.07258C15.7575 3.96869 15.8851 3.91675 16.0373 3.91675C16.1897 3.91675 16.3187 3.96869 16.4244 4.07258C16.5303 4.17633 16.5832 4.30494 16.5832 4.45841V16.2436C16.5832 16.6121 16.452 16.9275 16.1896 17.1899C15.9273 17.4522 15.6119 17.5834 15.2434 17.5834H5.34609ZM7.24338 13.7565H12.4998C12.5747 13.7565 12.6362 13.7325 12.6842 13.6845C12.7323 13.6364 12.7563 13.5749 12.7563 13.5001V3.75654C12.7563 3.68168 12.7323 3.62022 12.6842 3.57217C12.6362 3.52411 12.5747 3.50008 12.4998 3.50008H7.24338V13.7565ZM6.16005 13.7565V3.50008H5.34609C5.10623 3.50008 4.90525 3.58716 4.74317 3.76133C4.58095 3.9355 4.49984 4.1305 4.49984 4.34633V13.9984C4.61623 13.9301 4.74532 13.8727 4.88713 13.8261C5.02893 13.7797 5.18192 13.7565 5.34609 13.7565H6.16005Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const WhatsappIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.6683 4.328C14.1648 2.824 12.1628 2 10.0322 2C5.64221 2 2.06432 5.56 2.06432 9.928C2.06432 11.1873 2.36358 12.4143 2.92698 13.5215C3.04797 13.7593 3.086 14.0328 3.01556 14.2901L2.457 16.3305C2.25382 17.0728 2.93005 17.7568 3.67455 17.562L5.83885 16.996C6.08445 16.9317 6.3441 16.9658 6.57297 17.0757C7.64774 17.5915 8.83017 17.864 10.0322 17.864C14.4221 17.864 18 14.304 18 9.936C18 7.816 17.1719 5.824 15.6683 4.328ZM10.0322 16.52C8.84221 16.52 7.67638 16.2 6.65528 15.6C6.50098 15.5079 6.31615 15.4816 6.14229 15.5271L5.5812 15.6738C4.83645 15.8686 4.16015 15.1841 4.36385 14.4417L4.49465 13.965C4.54441 13.7837 4.51436 13.5898 4.41206 13.432C3.75276 12.384 3.39899 11.168 3.39899 9.928C3.39899 6.296 6.37387 3.336 10.0241 3.336C11.793 3.336 13.4573 4.024 14.7035 5.272C15.9578 6.52 16.6412 8.176 16.6412 9.936C16.6573 13.568 13.6824 16.52 10.0322 16.52ZM13.6663 11.592C13.4653 11.496 12.4844 11.016 12.3075 10.944C12.1226 10.88 11.994 10.848 11.8573 11.04C11.7206 11.24 11.3427 11.688 11.2302 11.816C11.1176 11.952 10.997 11.968 10.796 11.864C10.595 11.768 9.95176 11.552 9.19598 10.88C8.601 10.352 8.20703 9.704 8.08643 9.504C7.97387 9.304 8.07035 9.2 8.17487 9.096C8.26332 9.008 8.37588 8.864 8.47236 8.752C8.56884 8.64 8.60905 8.552 8.67337 8.424C8.73769 8.288 8.70553 8.176 8.65729 8.08C8.60904 7.984 8.20703 7.008 8.04623 6.608C7.88543 6.224 7.71658 6.272 7.59598 6.264C7.47538 6.264 7.34673 6.264 7.21005 6.264C7.07337 6.264 6.86432 6.312 6.6794 6.512C6.50251 6.712 5.98794 7.192 5.98794 8.168C5.98794 9.144 6.70352 10.088 6.8 10.216C6.89648 10.352 8.20703 12.352 10.201 13.208C10.6754 13.416 11.0452 13.536 11.3347 13.624C11.809 13.776 12.2432 13.752 12.5889 13.704C12.9749 13.648 13.7709 13.224 13.9317 12.76C14.1005 12.296 14.1005 11.904 14.0442 11.816C13.9879 11.728 13.8673 11.688 13.6663 11.592Z"
      fill="#4CAF50"
    />
  </svg>
);
